export const ugovor_o_zakupu = {
    templateId: 49.2,
    category: 5,
    templateTitle: "Ugovor o zakupu",
    templateDescription: `<p>Ugovor o zakupu je ugovor kojim se jedna ugovorna strana, zakupodavac obvezuje drugoj ugovornoj strani, zakupniku predati određenu stvar (ili pravo) na korištenje, a druga ugovorna strana dužna je za to plaćati naknadu odnosno zakupninu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovor o zakupu je ugovor kojim se jedna ugovorna strana, zakupodavac obvezuje drugoj ugovornoj strani, zakupniku predati određenu stvar (ili pravo) na korištenje, a druga ugovorna strana dužna je za to plaćati naknadu odnosno zakupninu.</p>
    <p>Bitna razlika između najma i zakupa je u tome što najam ovlašćuje najmoprimca samo na uporabu, a zakup ovlašćuje zakupoprimca na uporabu i korištenje (crpljenje plodova).</p>
    <p>U slučaju da ugovorne strane ne odrede pobliže drugačije svoje obveze ugovorom, zakupodavac sukladno Zakonu ima sljedeće obveze:</p>
  
    <li> predati predmet zakupa zakupniku,</li>
    <li> održavati predmet zakupa,</li>
    <li> suzdržavati se od izmjena predmeta zakupa,</li>
    <br>
    <p>dok s druge strane, zakupnik ima sljedeće obveze:</p>

    <li> koristiti predmet zakupa u skladu s ugovorom, </li>
    <li> snositi troškove redovite uporabe predmeta zakupa,</li>
    <li> snositi troškove sitnih popravaka predmeta zakupa,</li>
    <li> plaćati zakupninu,</li>
    <li> vraiti predmet zakupa po prestanku zakupa,</li>
    <li> obavještavati zakupodavca o nepredviđenim opasnostima u odnosu na predmet zakupa.</li>

    <br>
    <p>Iz do sada iznesenog može se jasno zaključiti da su bitni sastojci ugovora o zakupu predmet zakupa i visina zakupnine pa ugovor nastaje kada se ugovorne strane sporazumiju o tim bitnim elementima. </p>
    <p>Predmet samog ugovora o zakupu može biti nekretnina, pokretnina, ali i pravo.</p>
    <p>Primjerom ugovora u nastavku uređuje se zakup poslovnog prostora.</p>
    <p>U sporovima iz zakupnih ili najamnih odnosa na nekretnini isključivo je nadležan sud na čijem području se nekretnina nalazi.</p>

    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>-  Sklapanje ugovora najmu umjesto ugovora o zakupu</strong></p>
    <p>Pojašnjenje:  u slučaju da je pravna osoba vlasnik stana ili poslovnog prostora te isti daje na korištenje trećoj strani, zaključuje se ugovor o zakupu.</p>

   
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
        signature: 'Zakupodavac:',
        inputs: [{
            type: 'input',
            required: true,
            placeholder: 'Posl. subjekt / Ime i prezime',        
        },
            {
                type: 'input',
                required: true,
                placeholder: 'Ulica i kućni broj',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'Mjesto',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'OIB',
            },
            {
                type: "input",
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
            }],
        suffix: ' (u daljnjem tekstu: Zakupodavac)',
        delimiter: `i`
    },
    {
        signature: 'Zakupnik:',
        inputs: [{
            type: 'input',
            required: true,
            placeholder: 'Posl. subjekt / Ime i prezime',        
        },
            {
                type: 'input',
                required: true,
                placeholder: 'Ulica i kućni broj',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'Mjesto',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'OIB',
            },
            {
                type: "input",
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
            }
        ],
        suffix: ' (u daljnjem tekstu: Zakupnik),'
    }
],

headline: 'zaključuju sljedeći',
title: 'UGOVOR O ZAKUPU POSLOVNOG PROSTORA',
noArticleNumbers: false,

articles: [
    {
        title: 'PREDMET ZAKUPA',
        mandatory: false,
        editable: false,
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [               
            {type: 'text', content: 'Zakupodavac daje, a Zakupnik prima u zakup sljedeći poslovni prostor površine'},
            {type: 'input', value: '', required: true,},
            {type: 'text', content: 'm2'},
            {type: 'text', content: ','},
            {type: 'text', content: 'koji se sastoji od'},
            {type: 'textarea', value: '', required: true, placeholder: 'Upisati opis nekretnine (nalazi se u listu A-vlastovnici zk izvatka)'},
            {type: 'text', content: 'te se nalazi u'},
            {type: 'input', value: '', required: true, placeholder: 'Upisati mjesto'},
            {type: 'text', content: ','},
            {type: 'input', value: '', required: true, placeholder:'Ulica i kućni broj' },
            {type: 'text', content: ', stojeći na k.č. broj:'},
            {type: 'input', value: '', required: true,},
            {type: 'text', content: ','},
            {type: 'text', content: 'upisan u knjigama Općinskog suda u'},
            {type: 'input', value: '', required: true,},
            {type: 'text', content: ','},
            {type: 'text', content: 'Zemljišnoknjižni odjel'},
            {type: 'input', value: '', required: true,},
            {type: 'text', content: ','},
            {type: 'text', content: 'u zk. ul. br.'},
            {type: 'input', value: '', required: true,},
            {type: 'text', content: ','},
            {type: 'text', content: 'katastarska općina'},
            {type: 'input', value: '', required: true,},
        ],
    }],
value: '',
},
    {
        title: 'ZAKUPNINA',
        mandatory: true,
        editable: false,
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    {type: 'text', content: 'Ugovorne strane suglasno utvrđuju zakupninu u  iznosu od '},
                    {type: 'input', value: '', required: true,},
                    {type: 'text', content: 'za period od '},
                    {type: 'input', value: '', required: true,},
                    {help: "Upisujete razdoblje. Npr. mjesečno, tromjesečno, polugodišnje, godišnje i sl..",},

                  ],
            }],
        value: '',
    },
    {
        title: 'TROŠKOVI URAČUNATI U ZAKUPNINU',
        mandatory: false,
        statements: [
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {type: 'text', content: 'U iznos zakupnine'},
                    {type: 'input', value: '', required: true, placeholder: 'je/nije'},
                    {type: 'text', content: 'uračunat iznos potrošnje električne energije.'},
                  ],
            },
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {type: 'text', content: '\r\nU iznos zakupnine'},
                    {type: 'input', value: '', required: true, placeholder: 'je/nije'},
                    {type: 'text', content: 'uračunat iznos potrošnje vode.'},
                  ],
            },
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {type: 'text', content: '\r\nU iznos zakupnine'},
                    {type: 'input', value: '', required: true, placeholder: 'je/nije'},
                    {type: 'text', content: 'uračunat iznos potrošnje fiksne telefonske linije.'},
                  ],
            },
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {type: 'text', content: '\r\nU iznos zakupnine'},
                    {type: 'input', value: '', required: true, placeholder: 'je/nije'},
                    {type: 'text', content: 'uračunat iznos internet potrošnje.'},
                  ],
            },
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {type: 'text', content: '\r\nU iznos zakupnine'},
                    {type: 'input', value: '', required: true, placeholder: 'je/nije'},
                    {type: 'text', content: 'uračunat iznos  vodne naknade.'},
                  ],
            },
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {type: 'text', content: '\r\nU iznos zakupnine'},
                    {type: 'input', value: '', required: true, placeholder: 'je/nije'},
                    {type: 'text', content: 'uračunat iznos komunalne naknade.'},
                  ],
            },
        ],
        value: '',
    },
    {
        title: 'PLAĆANJE',
        mandatory: true,
        editable: false,
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    { type: "text", content: "Zakupnik je dužan plaćati Zakupodavcu zakupninu u sljedećim rokovima:" },
                    {type: "textarea", value: "", required: true },
                  ],
            }],
        value: '',
    }, 
    {
        title: 'POREZI',
        mandatory: false,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                            {type: 'text', content: 'Sve poreze po pitanju poreza na dohodak od imovine po ovom Ugovoru obvezuje se snositi Zakupodavac.'},
                            {help: 'Navedeno pitanje poreza mjerodavno je samo u slučaju da je Zakupnik fizička osoba, osim u slučaju ako je vlasnik fizička osoba - poduzetnik, a navedeni poslovni prostor je upisan u dugotrajnu imovinu poslovnog subjekta.'},
                       ]
                    },
                    {
                        parts: [
                            {type: 'text', content: 'Obvezu Zakupodavca po osnovi poreza na dohodak od imovine po ovom Ugovoru obvezuje se snositi Zakupnik.'},
                            {help: 'Navedeno pitanje poreza mjerodavno je samo u slučaju da je Zakupnik fizička osoba, osim u slučaju ako je vlasnik fizička osoba - poduzetnik, a navedeni poslovni prostor je upisan u dugotrajnu imovinu poslovnog subjekta.'},
                       ]
                    },
            ],
                value: '',
            }
        ]
    },  
    {
        title: 'PRIMOPREDAJA',
        mandatory: false,
        examplecontent:true,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Zakupodavac se obvezuje, na dan primopredaje, poslovne prostorije predati u posjed Zakupniku, slobodne od osoba i stvari, o čemu će ugovorne strane sačiniti zapisnik o primopredaji, u koji će se unijeti svi relevantni podaci o predmetu zakupa.',
                help: "Primjerak primopredajnog zapisnika možete pronaći u kategoriji PUNOMOĆI, ZAPISNICI.",
                value: '',
            }],
    },   
    {
        title: "ODRŽAVANJE, POPRAVCI",
        mandatory: false,
        examplecontent:true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Zakupnik snosi troškove tekućeg održavanja.\r\nPod tekućim održavanjem smatraju se: čišćenje predmetnog poslovnog prostora, soboslikarski popravci i sitni nužni popravci. \r\nZakupnik je dužan izvršiti popravke oštećenja na poslovnom prostoru koje je sam tijekom korištenja uzrokovao.\r\nZakupnik nema pravo na naknadu za izvršeno održavanje poslovnog prostora i popravke, sukladno ostalim odredbama ovoga članka."},
            ]
      },
      {
        title: "PREINAKE",
        mandatory: false,
        examplecontent:true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Nakon primopredaje, Zakupnik će izvršiti eventualne potrebne preinake poslovnog prostora, radi prilagodbe potrebama poslovanja u poslovnom prostoru.\r\nO potrebnim preinakama poslovnog prostora, Zakupnik će unaprijed u pisanom obliku obavijestiti Zakupodavca.\r\nZakupnik ne smije bez prethodne pisane suglasnosti Zakupodavca činiti preinake poslovnog prostora kojima se mijenja konstrukcija, raspored, površina, namjena ili vanjski izgled poslovnog prostora. "},
            ]
      },
      {
        title: "OBVEZE ZAKUPNIKA",
        mandatory: false,
        examplecontent:true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Zakupnik je dužan čuvati poslovni prostor s pažnjom dobrog gospodarstvenika i u istom obavljati registriranu dopuštenu djelatnost."},
            ]
      },
    {
        title: 'TRAJANJE UGOVORA',
        mandatory: true,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                            {type: 'text', content: 'Ovaj ugovor se zaključuje na neodređeno vrijeme, počevši od'},
                            {type: 'input', value: '', required: true},                       ]
                    },
                    {
                        parts: [
                            {type: 'text', content: 'Ovaj ugovor se zaključuje na određeno vrijeme i traje od'},
                            {type: 'input', value: '', required: true},
                            {type: 'text', content: 'do'},
                            {type: 'input', value: '', required: true},
                         
                       ]
                    },
                   ],
                value: '',
            }
        ]
    },
    // {
    //     title: 'NADLEŽNOST',
    //     mandatory: false,
    //     statements: [
    //         {
    //             type: 'choice',
    //             mandatory: true,
    //             editable: false,
    //             choices: [
    //                 {
    //                     parts: [
    //                         {type: 'text', content: 'Zakupnik ne može predmet zakupa dati trećim osobama u podzakup bez pristanka Zakupodavca.'},
    //                    ]
    //                 },
    //                 {
    //                     parts: [
    //                         {type: 'text', content: 'Zakupnik može predmet zakupa dati trećima u podzakup, no o tome je dužan prethodno obavijestiti Zakupodavca.'},
    //                    ]
    //                 },
    //                 {
    //                     parts: [
    //                         {type: 'text', content: 'Zakupnik može predmet zakupa dati trećima u podzakup, bez pristanka Zakupodavca.'},
    //                    ]
    //                 }
    //             ],
    //             value: '',
    //         }
    //     ]
    // },
    {
        title: 'POVRAT PREDMETA ZAKUPA',
        mandatory: false,
        examplecontent:true,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Zakupnik se obvezuje, na dan prestanka zakupa, poslovne prostorije predati u posjed Zakupodavca, slobodne od osoba i stvari, o čemu će ugovorne strane sačiniti zapisnik o primopredaji, u koji će se unijeti svi relevantni podaci o predmetu zakupa.\r\nZakupnik ima pravo, kod predaje poslovnog prostora Zakupodavcu, odnijeti svoja sredstva, prateće instalacije i uređaje koje je unio u poslovni prostor. \r\nZakupnik se obvezuje, na dan prestanka zakupa, poslovne prostorije predati u posjed Zakupodavca, slobodne od osoba i stvari, o čemu će ugovorne strane sačiniti zapisnik o primopredaji, u koji će se unijeti svi relevantni podaci o predmetu zakupa.',
                help: "Primjerak primopredajnog zapisnika možete pronaći u kategoriji PUNOMOĆI, ZAPISNICI.",
                value: '',
            },
        ],
    }, 
    {
        title: 'OTKAZ UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'input',
                mandatory: true,
                editable: true,
                parts: [
                    {
                        type: 'text',
                        content: 'Svaka ugovorna strana može jednostrano, pisanim putem, bez navođenja razloga, pisanim putem otkazati ovaj Ugovor uz otkazni rok od'
                    },
                    {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
            {type: 'text', content: ', a koji počinje teći od trenutka dostave otkaza drugoj ugovornoj strani.'},],
            }],
    },
    {
        title: 'RASKID UGOVORA',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'U slučaju jedna ugovorna strana krši obveze iz ovog Ugovora, druga ugovorna strana može pisanim putem raskinuti ugovor uz otkazni rok od 30 dana, a koji počinje teći od trenutka dostave obavijesti o raskidu drugoj ugovornoj strani. \r\nKršenjem obveza iz ovog Ugovora smatrati će se: \r\n- ukoliko Zakupnik ne plaća zakupnine sukladno odredbama ovog Ugovora, \r\n- Zakupnik ne koristi prostor u skladu s odredbama ovog Ugovora, \r\n- Zakupodavac ometa Zakupnika u korištenja predmeta zakupa.',
                value: '',
            },
        ],
        value: '',
    }, 
    {
        title: 'DOSTAVA',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'U slučaju otkaza i raskida Ugovora, isti se mora drugoj ugovornoj strani dostaviti preporučenom pošiljkom putem pošte na adresu označenu u ovom Ugovoru ili na drugi pouzdan način.\r\nU slučaju nemogućnosti uredne osobne dostave pisane opomene i dostave otkaza zbog promjene adrese, odbijanja preuzimanja pismena ili drugih načina izbjegavanja primanja pismena, dostava se smatra uredno izvršenom danom predaje preporučene pošiljke pošti, bez obzira na to je li pošta bila u mogućnosti uručiti pisanu opomenu, odnosno otkaz ili drugo pismeno.  ',
                value: '',
            },
        ],
        value: '',
    },  
          {
        title: 'NADLEŽNOST',
        mandatory: false,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Zakupodavca.'
                            }
                        ]
                    },
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Zakupnika.'
                            }
                        ]
                    },
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                            },
                            {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},]
                    }
                ],
                value: '',
            }
        ]
    },
    {
        title: 'PRIMJENA UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                value: '',
            }],
    },
    {
        title: 'PRIMJERCI UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                value: '',
            }],
      },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/49.2_ugovor_o_zakupu.ts